import script from "./EmailMassSendPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmailMassSendPanel.vue?vue&type=script&setup=true&lang=ts"

import "./EmailMassSendPanel.vue?vue&type=style&index=0&id=80f0b376&lang=scss"
import "./EmailMassSendPanel.vue?vue&type=style&index=1&id=80f0b376&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80f0b376"]])

export default __exports__